import { render, staticRenderFns } from "./GroupSettingPageAdministrator.vue?vue&type=template&id=935fe6fc"
import script from "./GroupSettingPageAdministrator.vue?vue&type=script&lang=js"
export * from "./GroupSettingPageAdministrator.vue?vue&type=script&lang=js"
import style0 from "./GroupSettingPageAdministrator.vue?vue&type=style&index=0&id=935fe6fc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports